<template>
  <Catalog
    title="Маркетинговый источник"
    name-label="Название источника"
    description-label="Например: Сайт, Рекомендация, Холодный обзвон"
    submit-error="Укажите название маркетингового источника."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    :exact-id="createId"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import Catalog from "../Catalog.vue";

export default {
  name: "MarketingSource",
  components: { Catalog },
  mixins: [ catalogs ],
  props: {
    createId: { type: Number }
  },
  methods: {
    async fetchData(id) {
      return await this.getMarketingSourceById(id);
    },
    async putData(data) {
      return await this.putMarketingSource(data)
    },
    async postData(data) {
      return await this.postMarketingSource(data)
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/MarketingSources/MarketingSource.vue